import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useAnalytics } from '@Shared/useAnalytics';
import { getIsPurchasedVehicleStocknumberAvailable, getPurchasedVehicleStocknumber, getPurchasedVehicleYearMakeModel, getPurchasedVehicleTrim, getIsYearMakeModelAvailable } from '../ducks/selectors';
import { Wrapper, CarImageOuterWrapper, CarImageWrapper, CarImageInnerWrapper, CarImage, Title, Subtitle, Button } from '../../../../Shared/Account/PurchaseCard.styles';
import { POST_SALE_DASHBOARD_PATH } from '../constants';

const PostSaleCard = ({ isPurchasedVehicleStocknumberAvailable, isYearMakeModelAvailable, yearMakeModel, trim, stockNumber }) => {
  const imageSource = `${process.env.FASTLY_CDNBLOB_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg?width=250`;
  const { trackEventAndGo } = useAnalytics();

  return (
    <Wrapper className="top-padding">
      {isYearMakeModelAvailable && (
        <CarImageOuterWrapper className="bottom-spacing">
          <Title>
            <Subtitle className="bottom-padding">{yearMakeModel}</Subtitle>
            <Subtitle>{trim}</Subtitle>
          </Title>
          {isPurchasedVehicleStocknumberAvailable && (
            <CarImageWrapper className="extra-image-padding">
              <CarImageInnerWrapper>
                <CarImage src={imageSource} alt="Car" />
              </CarImageInnerWrapper>
            </CarImageWrapper>
          )}
        </CarImageOuterWrapper>)}
      <Button onClick={e => trackEventAndGo(e, 'clicked postsale dashboard link')} target="_self" href={POST_SALE_DASHBOARD_PATH}>View Dashboard</Button>
    </Wrapper>
  );
};

PostSaleCard.defaultProps = {
  stockNumber: 0
};

PostSaleCard.propTypes = {
  isPurchasedVehicleStocknumberAvailable: PropTypes.bool.isRequired,
  isYearMakeModelAvailable: PropTypes.bool.isRequired,
  yearMakeModel: PropTypes.string.isRequired,
  trim: PropTypes.string.isRequired,
  stockNumber: PropTypes.number
};

const mapStateToProps = state => ({
  isPurchasedVehicleStocknumberAvailable: getIsPurchasedVehicleStocknumberAvailable(state),
  isYearMakeModelAvailable: getIsYearMakeModelAvailable(state),
  stockNumber: getPurchasedVehicleStocknumber(state),
  yearMakeModel: getPurchasedVehicleYearMakeModel(state),
  trim: getPurchasedVehicleTrim(state)
});

export default connect(mapStateToProps)(PostSaleCard);
